import React from 'react';

import ApiSitesContainer from '@totem/components/administration/apiSites/ApiSitesContainer';
import ApiSitesLayout, {
  ApiSitesExtra,
} from '@totem/components/administration/apiSites/ApiSitesLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const ApiSitesPage = () => (
  <ContentLayout>
    <ApiSitesContainer>
      <IBCard isCovered title="API Sites" extra={<ApiSitesExtra />}>
        <ApiSitesLayout />
      </IBCard>
    </ApiSitesContainer>
  </ContentLayout>
);

export default ApiSitesPage;
